import axios from 'axios';

const api = axios.create({
  baseURL: 'https://tvpersonal-backend.herokuapp.com/',
});

export function setDefaultHeaders(headers) {
  api.defaults.headers = headers;
}

export default api;
